import { Skeleton, Spinner } from '@sendible/design-system';

interface Props {
  useSpinner?: boolean;
}

export const LoadingState = ({ useSpinner }: Props) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {useSpinner ? (
      <Spinner size="xl" />
    ) : (
      Array(6)
        .fill(' ')
        .map((_, i) => (
          <Skeleton
            key={`skeleton-${i}`}
            width="9rem"
            height="9rem"
          />
        ))
    )}
  </>
);
